import React, { Component } from "react";

import { Navbar, Nav, NavItem, NavDropdown, MenuItem, Collapse } from 'react-bootstrap';
import Scroll from 'react-scroll';
import NavButton from "./NavButton.jsx";
import Image from "./Image.jsx";
import AnimateOnChange from "react-animate-on-change";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import onClickOutside from "react-onclickoutside";

import herbalAktivLogo from "../../images/hap-logo.jpg";
import herbs2peelLogo from "../../images/herbs2peel logo.png";
import alexLogo from "../../images/alex-logo.png";
import data from "../../core/data";

class NavigationBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: false,
			toggle: false
		};
	}

	render() {
		return (
			<Navbar onToggle={ this.handleToggle } expanded={ this.state.toggle } fixedTop fluid>
				<a className="hap logo" href="/">
					<Image src={ herbalAktivLogo } alt="Herbal Aktiv Peel Logo" />
				</a>
				<a className="h2p logo hidden-xs" href="/">
					<Image src={ herbs2peelLogo } alt="Herbs 2 Peel Logo" />
				</a>
				<a className="alex logo hidden-xs" href="/bb-cream">
					<Image src={ alexLogo } alt="Alex Cosmetics Logo" />
				</a>
				<Navbar.Toggle />
				<Navbar.Collapse>
					<ul className="nav navbar-nav">
						<li onClick={ this.handleClick }><a>Herbal Aktiv Peel ▾</a></li>
						<Collapse className="sub" in={ this.state.selected }>
							<div className="container">
								<ul className="nav navbar-nav">
									<li onClick={ this.handleSelect }><NavButton path="/" name="CPeel" /></li>
			            <li onClick={ this.handleSelect }><NavButton path="b-peel" name="BPeel" /></li>
			            <li onClick={ this.handleSelect }><NavButton path="p-peel" name="PPeel" /></li>
			            <li onClick={ this.handleSelect }><NavButton path="testimonials" name="Testimonials" /></li>
			            <li onClick={ this.handleSelect }><NavButton path="about" name="About Us" /></li>
								</ul>
							</div>
						</Collapse>
						<li onClick={ this.handleSelect } role="presentation"><NavButton path="bb-cream" name="BBCream" /></li>
						<li onClick={ this.handleSelect } role="presentation"><NavButton path="success-stories" name="Success Stories" /></li>
						<li onClick={ this.handleSelect } role="presentation"><NavButton path="social-media" name="In the Media" /></li>
						<li onClick={ this.handleSelect } role="presentation"><NavButton path="news" name="News" /></li>
						<li><Scroll.Link
							onClick={ this.handleSelect }
	 						to="contact-form"
	 						smooth={ true }
	 						duration={ 500 }>
	 						Find a Clinic
	 					</Scroll.Link></li>
						<li><p>Call Us: { data.contact.number }</p></li>
					</ul>
				</Navbar.Collapse>
			</Navbar>
		)
	}

	handleClick = () => {
		this.setState((prevS, props) => {
			return { selected: !prevS.selected }
		});
	};

	handleClickOutside = event => {
		this.setState({
			toggle: false,
			selected: false
		});
	};

	handleToggle = () => {
		this.setState((prevS, props) => {
			return { toggle: !prevS.toggle }
		});
	};

	handleSelect = () => {
		this.setState({ toggle: false });
	};
}

export default onClickOutside(NavigationBar);



/** WEBPACK FOOTER **
 ** ./src/components/presentational/NavigationBar.jsx
 **/